import App from './App.vue';

export default {
  path: '/CDS_VF_RequestDetail',
  name: 'CDS_VF_RequestDetail',
  component: App,
  meta: {
    pageProperty: {
      title: '支援要請詳細',
      controller: 'CDS_CTR_RequestDetail',
    },
  },
};
